<div class="page" [ngStyle]="{ 'min-height': tabScrollHack }">
  <ng-container *ngIf="product.headerImageUrl; else defaultBanner">
    <div class="background-logo">
      <img [src]="product.headerImageUrl" [srcset]="srcsetHeaderImage" class="bannerImage" />
    </div>
  </ng-container>

  <ng-template #defaultBanner>
    <div class="background-logo">
      <img [src]="defaultHeaderImage" class="defaultBannerImage" />
    </div>
  </ng-template>
  <div>
    <div *ngIf="mobileLayout; else webLayout" class="mobile-container">
      <div class="flex-row">
        <div class="icon">
          <va-icon [iconUrl]="product.iconUrl" [iconName]="product.name" [diameter]="60"></va-icon>
        </div>
        <div class="centered-column">
          <div class="title">{{ product.name }}</div>
          <div class="tag-line">{{ product.tagline }}</div>
        </div>
      </div>
      <div class="mobile-chip-container">
        <mat-chip-listbox>
          <div class="flex-row">
            <div id="chipStart"></div>
            <div class="chip-list">
              <mat-chip-option *ngFor="let chip of chipLabels" class="chipItem">
                {{ chip }}
              </mat-chip-option>
            </div>
            <div class="more-chip-spacer">
              <mat-chip-option
                *ngIf="showMoreChip"
                [matTooltip]="overflowTagsList"
                (mouseenter)="$event.stopImmediatePropagation()"
                (mouseleave)="$event.stopImmediatePropagation()"
                #tooltip="matTooltip"
                (click)="tooltip.toggle()"
                class="more-chip"
                [ngStyle]="{ left: moreChipPosition }"
              >
                <span [matBadge]="hiddenChipNum" [matBadgeOverlap]="false">
                  {{ onlyMore ? ('FRONTEND.STORE.TAGS' | translate) : ('FRONTEND.STORE.MORE' | translate) }}
                </span>
              </mat-chip-option>
            </div>
          </div>
        </mat-chip-listbox>
      </div>

      <div *ngIf="isHeaderActionUsed || isContactActionUsed" class="product-actions-container">
        <span>
          <button mat-stroked-button *ngIf="isContactActionUsed" (click)="contactActionClick.emit()">
            {{ 'FRONTEND.STORE.CONTACT_US' | translate }}
          </button>
        </span>
        <div [glxyTooltip]="getHeaderActionTooltip()">
          <button
            data-action="clicked-product-action-button"
            class="primary-action-button"
            *ngIf="isHeaderActionUsed"
            mat-raised-button
            color="primary"
            [disabled]="isHeaderActionButtonDisabled()"
            (click)="onHeaderActionClicked()"
          >
            <span>{{ getEnableButtonText() }}</span>
          </button>
        </div>
      </div>
    </div>

    <ng-template #webLayout>
      <div class="web-container">
        <div class="icon-container">
          <div class="icon">
            <va-icon [iconUrl]="product.iconUrl" [iconName]="product.name" [diameter]="120" id="thing"></va-icon>
          </div>
        </div>
        <div class="web-center-container">
          <div class="web-name-chips-container">
            <div class="title small-gutter">{{ product.name }}</div>
            <div class="web-chip-container" *ngIf="!this.hideTags">
              <mat-chip-listbox>
                <div class="flex-row">
                  <div id="chipStart"></div>
                  <div class="chip-list">
                    <mat-chip-option *ngFor="let chip of chipLabels" class="chipItem">
                      {{ chip }}
                    </mat-chip-option>
                  </div>
                  <div class="more-chip-spacer">
                    <mat-chip-option
                      *ngIf="showMoreChip"
                      [matMenuTriggerFor]="menu"
                      class="more-chip"
                      [ngStyle]="{ left: moreChipPosition }"
                    >
                      <span [matBadge]="hiddenChipNum" [matBadgeOverlap]="false">
                        {{ onlyMore ? ('FRONTEND.STORE.TAGS' | translate) : ('FRONTEND.STORE.MORE' | translate) }}
                      </span>
                    </mat-chip-option>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item *ngFor="let tag of moreList">
                        <li>{{ tag }}</li>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </mat-chip-listbox>
            </div>
          </div>
          <div class="tag-line small-gutter">
            {{ product.tagline }}
          </div>
        </div>
        <div
          *ngIf="isHeaderActionUsed || isContactActionUsed"
          id="web-action-container"
          class="web-product-actions-container"
        >
          <span>
            <button mat-stroked-button *ngIf="isContactActionUsed" (click)="contactActionClick.emit()">
              {{ 'FRONTEND.STORE.MESSAGE_US' | translate }}
            </button>
          </span>

          <div [glxyTooltip]="getHeaderActionTooltip()">
            <button
              data-action="clicked-product-action-button"
              class="primary-action-button"
              *ngIf="isHeaderActionUsed"
              mat-raised-button
              color="primary"
              [disabled]="isHeaderActionButtonDisabled()"
              (click)="onHeaderActionClicked()"
            >
              <span>{{ getEnableButtonText() }}</span>
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <ng-container *ngIf="tabState$ | async as tabState">
    <mat-tab-group [selectedIndex]="tabState.tab" (selectedTabChange)="onTabChanged($event)">
      <mat-tab label="{{ 'FRONTEND.STORE.PRODUCT_DETAILS.TAB_LABELS.PRODUCT_INFORMATION' | translate }}">
        <store-product-info
          [product]="product"
          [partnerId]="partnerId"
          [marketId]="marketId"
          [appPrice]="appPrice"
          [addonPrices]="addonPrices"
          [currency]="currency"
          [isAddon]="isAddon"
          [marketingType]="marketingType"
          [personaType]="personaType"
          [orderForm]="orderForm"
          [usesActivationSpecificEntryUrl]="usesActivationSpecificEntryUrl"
          [fulfillmentOrderConfig]="fulfillmentOrderConfig"
          (addonSelected)="addonSelected.emit($event)"
          (editionTabSelected)="selectEditionTab($event)"
        ></store-product-info>
      </mat-tab>
      <mat-tab label="{{ 'FRONTEND.STORE.PRODUCT_DETAILS.TAB_LABELS.SCREENSHOTS_AND_FILES' | translate }}">
        <store-screenshots-files [app]="product"></store-screenshots-files>
      </mat-tab>
      <mat-tab
        *ngIf="tabState.editionsTabVisible"
        label="{{ 'FRONTEND.STORE.PRODUCT_DETAILS.TAB_LABELS.EDITIONS_AND_PRICING' | translate }}"
      >
        <ng-template matTabContent>
          <store-editions-marketing
            [contactSales]="product.shouldContactSales"
            [marketingType]="marketingType"
            [billingPrice]="billingPrice"
            [appPrice]="appPrice"
            [currency]="currency"
            [editionsMarketing]="editionsMarketing"
            [editionOrder]="editionOrder"
            [isEditionActionUsed]="isEditionActionUsed"
            (editionActionClick)="onEditionActionClicked($event)"
          ></store-editions-marketing>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>
